import React from 'react';
import { WidgetRequestType } from 'shared/types/graphql';
import { WidgetRequestTypeLabels } from '@televet/shared-types/widgetRequest/WidgetRequestTypeLabels';
import { ClinicWidgetRequestTypeResponse } from 'shared/types';
import { env } from 'env';
import { ProdClinicIds } from 'shared/enums/ClinicMap';
import { Flex, VStack } from '@televet/kibble-ui/build/chakra';
import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Icon } from '@televet/kibble-ui/build/components/Icon';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Card } from '@televet/kibble-ui/build/components/Card';
import { useWidgetStore } from 'state/useWidgetStore';
import RequestTypeIcon from 'shared/components/RequestTypeIcon';

interface RequestTypeListProps {
  requestTypes?: ClinicWidgetRequestTypeResponse[] | null;
  headingContents?: string | JSX.Element;
  handleRequestTypeClick: (request: ClinicWidgetRequestTypeResponse) => Promise<void>;
}

const RequestTypeList = ({ requestTypes, handleRequestTypeClick }: RequestTypeListProps): JSX.Element | null => {
  const { clinicId } = useWidgetStore((state) => state);

  return (
    <VStack
      className="RequestTypeList__Container"
      overflow="auto"
      w="100%"
      align="flex-start"
      justify="stretch"
      p={4}
      spacing={3}
    >
      {requestTypes?.map((request) => {
        if (!request) return <></>;
        const { requestType, id, displayName } = request;
        const label = displayName || WidgetRequestTypeLabels[requestType];

        if (requestType === WidgetRequestType.TalkToStaff) {
          return (
            <Card className="RequestTypeList__Item--TalkToStaff" key={id} boxShadow="base" w="100%">
              {env.NODE_ENV === 'production' && clinicId === ProdClinicIds.Hurricane ? null : (
                <Flex flexDir="column" mb={4} gap={2}>
                  <Heading size="xs">Need to talk to someone about your pet?</Heading>
                  <Text size="sm">We&apos;re standing by to answer all of your questions.</Text>
                </Flex>
              )}

              <Button isFullWidth={true} onClick={(): Promise<void> => handleRequestTypeClick(request)}>
                {label}
              </Button>
            </Card>
          );
        }

        return (
          <Button
            className="RequestTypeList__Item"
            key={id}
            onClick={(): Promise<void> => handleRequestTypeClick(request)}
            variant="secondarySubtle"
            boxShadow="base"
            justifyContent="space-between"
            data-testid="request-type-button"
            isFullWidth
            size="lg"
            h="100%"
          >
            <Flex gap={2} whiteSpace="break-spaces">
              <RequestTypeIcon requestType={requestType} size="md" />
              <Text align="left" size="sm">
                {label}
              </Text>
            </Flex>
            <Icon name="chevronRight" size="sm" />
          </Button>
        );
      })}
    </VStack>
  );
};
export default RequestTypeList;
